import React from 'react'
import DocumentTitle from 'react-document-title'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Input from '_/shared/components/input'
import { Button, Row, Col } from 'react-bootstrap'
import { Map, List } from 'immutable'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import getDisplayName from '_/utils/getDisplayName'

@ReactMixin.decorate(ImmutableRenderMixin)
class NewRecord extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    metro: React.PropTypes.object.isRequired,
    metadata: React.PropTypes.object.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func
  }

  static fetchData (store) {
    return {
      metro: store.get('/account/metro')
    }
  }

  constructor (props, context) {
    super(props, context)
    let genUseTM = List()

    if (props.account.get('isAgRes')) {
      const group = props.account.get('group')
      const agGenUse = group.get('isAg') && List(['Agriculture'])
      const sfrGenUse = group.get('isSfr') && List(['Single Family Residential'])
      genUseTM = agGenUse || sfrGenUse
    }

    this.state = {
      isLookup: props.account.get('isAdmin') ? false : true,
      property: Map({ genUseTM }),
      link: createLinkToImmutable(this, 'property')
    }
  }

  handleSelect (id, propertyOpt) {
    this.setState({
      property: this.state.property.set('id', id),
      propertyOpt
    })
  }

  handleOptions (data) {
    return data.map(r => {
      return { value: r.get('id'), label: getDisplayName('property', r) }
    }).toJS()
  }

  async create (evt) {
    evt.preventDefault()
    const { store, router } = this.context
    const { property } = this.state
    try {
      const newProp = await store.post('/records', property)
      router.transitionTo('record', { id: newProp.get('id') })
    }
    catch (er) {
      console.error(er)
    }
  }

  toggleMode (evt) {
    evt.preventDefault()
    this.setState({ isLookup: !this.state.isLookup })
  }

  renderLookup () {
    const { propertyOpt } = this.state

    return (
      <div>
        <Input
          type="select-ajax"
          value={propertyOpt}
          handleOptions={::this.handleOptions}
          onChange={::this.handleSelect}
          name="records"
          url="/records?isPrivate=false&minimal=true"
          label="Locate a property" />
        <div className="pull-right">
          Can't find the property? <a href="" onClick={::this.toggleMode}>Add a new property</a>.
        </div>
        <Button
          type="submit"
          bsStyle="primary">
          Create
        </Button>
      </div>
    )
  }

  renderCreate () {
    const { link } = this.state
    const { account, metro } = this.props
    const metadata = this.context.store.metadata.get('property')

    return (
      <div>
        <Row>
          <Col xs={6}>
            <Input
              type="text"
              valueLink={link('pid')}
              label="Primary parcel no." />
          </Col>
          <Col xs={4}>
            <Input
              type="select"
              valueLink={link('county')}
              options={
                metro.get('countiesM').map(county => ({
                  label: county,
                  value: county
                }))
                .toJS()
              }
              label="County" />
          </Col>
          <Col xs={2}>
            <Input
              type="select"
              valueLink={link('state')}
              options={
                metro.get('statesM').map(state => ({
                  label: state,
                  value: state
                }))
                .toJS()
              }
              label="State" />
          </Col>
        </Row>

        {!account.get('isAgRes') &&
          <Input
            multi
            type="select"
            valueLink={link('genUseTM')}
            options={
              metadata.getIn(['genUseTM', 'enumValues']).map(use => ({
                label: use,
                value: use
              }))
              .toJS()
            }
            label="General property use" />
        }

        {!account.get('isAdmin') &&
          <div className="pull-right">
            Search for property instead? <a href="" onClick={::this.toggleMode}>Find and add</a>.
          </div>
        }

        <Button
          type="submit"
          bsStyle="primary">
          Create
        </Button>
      </div>
    )
  }

  render () {
    const { isLookup } = this.state

    return (
      <DocumentTitle title="Create a new record">
        <form onSubmit={::this.create}>
          <h3>Create a new record</h3>
          {isLookup ? this.renderLookup() : this.renderCreate()}
        </form>
      </DocumentTitle>
    )
  }
}

export default NewRecord



// WEBPACK FOOTER //
// ./modules/shared/pages/record/newRecord.js